import { getStaticDocUrl } from "../utils/staticDocumentUrls"
import React, { useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"

const SamsungESOptin1 = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <>
        Acepto el envio de comunicaciones comerciales sobre productos financieros y de seguros de entidades del Grupo
        BNP Paribas en España previa realizacíon de un perfilado de mis datos y consulta a sistema externos de
        información crediticia.
        <u onClick={() => setShow(true)} className="clickable">
          Más información
        </u>
      </>
      <Modal show={show} onHide={() => setShow(false)} className="modal-info">
        <Modal.Body>
          <div id="dropin-container">
            Consiento expressamente que Banco Cetelem, S.A.U. pueda enviarme comunicaciones comerciales de productos
            financieros y de seguros de entidades del Gtupo BNP Paribas en España y. en especial de ofertas de seguros
            mediados por Banco Cetelem S.A.U, OBSV, mediante qualquier medio, includos electrónicos, tales com SMS, MMS,
            email, whatsapp, etc, previo perfilado de mis datos personales y el enriquecimento de los mismos mediante
            bases de datos externas, así como la consulta a ficheros de solvencia patrimonial y crédito mientras esté
            vigente el contrato y durante los 24 meses siguientes a la finalización del mismo.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row className="justify-content-md-center">
            <Col md={6} lg={6}>
              <Button variant="outline-primary" onClick={() => setShow(false)}>
                Acceptar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const SamsungESOptin2 = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <>
        Acepto el envío de comunicaciones comerciales sobre productos de terceras entidades con las que Banco Cetelem
        S.A.U. mantenga acuerdos comerciales, previo realizacíon de un perfilado de mis datos y consulta a sistemas
        externos de informacíon crediticia.
        <u onClick={() => setShow(true)} className="clickable">
          Más información
        </u>
      </>
      <Modal show={show} onHide={() => setShow(false)} className="modal-info">
        <Modal.Body>
          <div id="dropin-container">
            Consiento expresamente que Banco Cetelem S.A.U. pueda enviarme comunicaciones comerciales de terceras
            entidades con las que Banco Cetelem S.A.U. mantenga acuerdos comerciales, de los sectores finianciero, ocio,
            formación, gran consumo, editorial, automoción, energia, agua, electrodomésticos, informática, muebles,
            cocina, textil deporte y reformas del hogar, y en especial de ofertas de seguros mediados por Banco Cetelem,
            S.A.U. OBSV, mediante qualquer medio, incluidos electrónicos, tales como SMS, MMS, email, whatsapp, etc,
            previo perfilado de mis datos personales y el enriquecimiento de los mismos mediante bases de datos
            externas, así como la consulta a ficheros de solvencia patrimonial y crédito mientras esté vigente el
            contrato y durante los 24 meses siguientes a la finalización del mismo.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row className="justify-content-md-center">
            <Col md={6} lg={6}>
              <Button variant="outline-primary" onClick={() => setShow(false)}>
                Acceptar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export var es_ES = {
  Retry: "Reintentar",
  Continue: "Continuar",
  "Secure payment": "Pago seguro",
  "Payment validation": "Validación del pago",
  "Validation de votre paiement en cours": "Validación de su pago en curso",
  "Complete your payment with Aplazame.": "Completa tu pago con Aplazame.",
  AplazameConfirmation: "Confirmación",
  "Complete your secure payment below.": "Completa tu pago seguro a continuacion.",
  "Initializing secure payment...": "Inicializando el pago seguro...",
  "Unable to submit payment. Please try again.": "No se ha podido enviar el pago. Intentalo de nuevo.",
  "Payment initialization is taking longer than expected. Please try again or contact support.":
    "La inicialización del pago está tardando más de lo esperado. Inténtalo de nuevo o contacta con soporte.",
  Finalization: "Confirmación",
  /* ========================================== */
  /* COMMON =================================== */
  /* ========================================== */
  "Back to shop": "Volver a la Tienda",
  "Redirecting to Samsung shop shortly": "Le redirigiremos a la tienda de Samsung en un instante.",
  Back: "Retroceso",
  Validate: "Validar",
  "Your transaction is being finalized.": "Su transacción se está finalizando.",
  "Select...": "Escoger...",
  Choose: "Elegir",
  Start: "Empezar",
  civility_mr: "Sr.",
  civility_mrs: "Sra.",
  /* ========================================== */
  /* BREADCRUMB =============================== */
  /* ========================================== */
  Services: "Servicios",
  Informations: "Información necesaria",
  "My informations": "Mis informaciones",
  Summary: "Resumen",
  "My summary": "Mi resumen",
  Contracts: "Identificación y firma del contrato",
  "Back to basket": "Volver a la Shop",
  /* ========================================== */
  /* BASKET =================================== */
  /* ========================================== */
  "including services at": "servicios ya incluidos por",
  Basket: "Carrito",
  Accessories: "Accesorios",
  "Promo code": "Código promocional",
  Included: "Incluido",
  on: "sobre",
  months: "meses",
  Offered: "ofrecidos",
  "Shipping fees": "Gastos de entrega",
  Upfront: "Autorizacion para el primer pago",
  "My upfront": "Mi primer pago",
  Rent: "Cuota",
  "/month": "/mes",
  months_uppercase: " Meses",
  YYYY: "AAAA",
  "YYYY/MM/DD": "DD/MM/AAAA",
  "including services pack at": "cuyo conjunto de servicios",
  "Supporting documents requested": "¿Qué necesitas?",
  "A bank card in your name": " Cuenta bancaria",
  "Your mobile phone": "Tu teléfono móvil",
  "A bank identity statement in your name": "Un certificado de titularidad bancaria",
  "My RIB": "Mi justificante bancario",
  "Your banking credentials": "Sus datos bancarios (para recuperar su extracto bancario)",
  "Mon relevé bancaire": "Mi extracto bancario",
  "A valid ID in your name": "Tener a mano tu documento de identidad original",
  "My ID": "Mi justificante de identidad",
  "My valid ID": "Mi justificante de identidad válido",
  "Proof of address of less than 3 months": "Tu última nómina",
  /* ========================================== */
  /* ONBOARDING PAGE ========================== */
  /* ========================================== */
  "Select your services and customize the options of your rental contract.":
    "Selecciona tus servicios y personaliza tus opciones de contrato de arrendamiento.",
  "Identity document type": "Tipo de documento",
  "Here are the steps to follow to make your rental request":
    "Estos son los pasos a seguir para realizar tu solicitud de arrendamiento (Renting)",
  "The online subscription procedure is fully dematerialized.": "El proceso de contratación es electrónico.",
  "The signing of your contract and the downloading of your supporting documents will be done by electronic way.":
    "La firma de tu contrato de solicitud de arrendamiento se realizará de forma electrónica y te enviaremos el ejemplar de los documentos contractuales a tu correo electrónico.",
  "Pay by credit card the 1st installment of your rental contract.":
    "Paga por tarjeta bancaria el primer pago de tu contrato de arrendamiento",
  "through bank card to reserve my product": "por tarjeta bancaria para reservar mi producto",
  "Check and complete your personal information which will appear on your contract.":
    "Completa tu información personal, que aparecerá en tu contrato.",
  "Validate your personal information and your rental request.":
    "Valida tu información personal y tu solicitud de arrendamiento.",
  "which allow me to validate my informations and my rent request":
    "que me permiten validar mi información y mi solicitud de arrendamiento",
  "Download your supporting documents and sign your dematerialized contract.":
    "Descarga los comprobantes y la firma de tu contrato electrónico. Por tu seguridad vamos a identificarte.",
  "Automatically verify your identity through Facematch, and then take a photo of your ID and yourself, the steps are specified throughout the process.":
    "Vamutoriza la verificacion de tu identitad a travès de Facematch,para luego tomar una foto de tu DNI y de ti mismo, se te especifian los passos a lo largo del procesp.",
  "To complete your subscription request, have the following information ready:":
    "Para poder formalizar tu solicitud de arrendamiento, necesitas:",
  "A good internet connection": "Una buena conexión a Internet",
  "Being in a well-lit place": "Estar en un lugar bien iluminado",
  "Bank card": "Tarjeta bancaria",
  "Photo of your ID": "Foto del DNI",
  "Your photo": "Foto tuya",
  /* ========================================== */
  /* SERVICES PAGE ============================ */
  /* ========================================== */
  /* ========================================== */
  /* UPFRONT PAGE ============================= */
  /* ========================================== */
  "first installment of your rental contract": "Autorizacion para el primer pago",
  "Cards accepted": "Tarjetas aceptadas",
  "Cards not accepted": "Tarjetas no aceptadas",
  "Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.":
    "Tarjetas con autorización sistemática (Electrón, Maestro, American Express, tarjetas de prepago o recargables, e-CB)",
  "The 1st payment of ": "El primer pago de",
  " by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    " por tarjeta bancaria sólo será efectivo trás la firma de tu contrato de arrendamiento y trás descargar tus comprobantes. Si tu solicitud de arrendamiento está denegada por el arrendador después de su estudio, entonces este importe será inmediatamente reembolsado.",
  "Systematically authorized cards (such as Electron, Maestro, prepaid, rechargeable), e-CB and American Express.":
    "Tarjetas con autorización sistemática (Electrón, Maestro, tarjetas de pre-pago or recargables, American Express y e-CB).",
  "Upfront amount of your leasing contract": "Primer pago de tu contrato de arrendamiento",
  "Card number": "Número de tarjeta",
  MM: "MM",
  CB: "CB",
  Visa: "Visa",
  Mastercard: "Mastercard",
  "Your credit card is expired": "Tu tarjeta ha caducado",
  "Expiration date": "Fecha de caducidad",
  CVV: "CVV",
  "I, undersigned $ certify that I am the holder of the bank card used for the request for payment of my 1st payment.":
    ["Yo ", " certifico ser el titular de la tarjeta bancaria utilizada para la formalización de mi primer pago"],
  "Secured payment": "Pago seguro",
  "validate the payment authorization": "Validar la autorización de pago",
  "Your card has been declined. Please check the accuracy of the information entered. You can also contact your bank to verify that it is not blocking payment.":
    "Tu tarjeta ha sido denegada. Gracias por verificar la exactitud de la información rellenada. Puedes también contactar tu banco para verificar que no estuviera bloqueando el pago.",
  "penalties for contract": "Las cantidades mostradas a lo largo del proceso de contratación incluyen IVA.",
  "penalty calculation": " ",
  "penalty click": " ",
  "for simulation": " ",
  "This step only constitutes a request for authorization of payment.":
    "Este paso es solo una solicitud de autorización de pago.",
  " The 1st payment of ": " El 1er pago de ",
  "by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    "con tarjeta de crédito solo será efectivo después de descargar sus documentos de respaldo y después de firmar su contrato de alquiler. Si su solicitud de alquiler es posteriormente denegada por el arrendador tras su estudio, esta cantidad le será reembolsada inmediatamente.",
  /* ========================================== */
  /* CLIENT DATA PAGE ========================= */
  /* ========================================== */
  "Tax number": "DNI/NIE",
  "Identification expiration date": "Fecha de caducidad DNI/NIE",
  "Bank Seniority": "Año de ingreso en tu banco actual",
  "My identity": "Mi identidad",
  "My coordinates": "Mi contacto",
  "My situation": "Mi Situación",
  "My budget": "Mi presupuesto",
  "Type of residence": "Tipo de residencia",
  "The information below is necessary for our renter for the constitution of your rental file.":
    "Las informaciones debajo son necesarias para nuestro arrendador para la constitución de tu dosier de arrendamiento",
  "To meet our eligibility conditions, you must have regular activity income and not have any current payment incidents.":
    "Para rellenar nuestras condiciones de elegibilidad, debes tener un trabajo con ingresos regulares y no tener incidentes de pago en curso.",
  Identity: "Identidad",
  Title: "Tratamiento",
  Mr: "Señor",
  Ms: "Señora",
  "Last name": "Apellidos",
  "Last second name": "Segundo apellido",
  "First name": "Nombre",
  Address: "Dirección",
  "Enter the address that will appear on your contract.": "Rellena la dirección que aparecerá en tu contrato",
  "Address 2": "Complemento de dirección",
  Locality: "Provincia",
  Zip: "Código postal",
  City: "Ciudad",
  Birth: "Nacimiento",
  Birthdate: "Fecha de nacimiento",
  "Department of birth": "Provincia de nacimiento",
  "City of birth": "Ciudad de nacimiento",
  "Country of birth": "País de nacimiento",
  "Country of residence": "País de residencia",
  Province: "Provincia",
  Citizenship: "Nacionalidad",
  Contact: "Contacto",
  Mobile: "Móvil",
  Email: "Email",
  "Contract type": "Tipo de contrato",
  Occupation: "Empleo",
  "Since...": "Desde",
  " since ": " desde ",
  Finances: "Finanzas",
  "Your net monthly income": "Tus ingresos mensuales netos",
  "over 12 months": "sobre 12 meses",
  "over 13 months": "sobre 13 meses",
  "over 14 months": "sobre 14 meses",
  "over 15 months": "sobre 15 meses",
  "over 16 months": "sobre 16 meses",
  "Other monthly income": "Otros ingresos mensuales",
  "Property income or alimony paid": "Ingresos de la propiedad o pensión alimenticia recibida",
  "Your share of monthly charges": "Tu parte de cargos mensuales",
  "Rent or mortgage": "Alquiler o crédito inmobiliario",
  "Rent or mortgage EVO":
    "Alquiler(es) o cuota(s) de crédito(s) hipotecario(s), Crédito en curso fuera de la vivienda, Gastos de guardería",
  "Net monthly income tooltip":
    "Salario + prima(s), Pensión(es) y pre-pensión(es), Ingresos de actividad liberal, Pensiones, etc.",
  "Other monthly charges": "Otros cargos mensuales",
  "Credit (excluding mortgage) and / or alimony paid":
    "Crédito (otro que crédito inmobiliario) y/o pensión alimenticia pagada",
  Housing: "Casa",
  "Family situation": "Situación familial",
  "Number of dependent children": "Número de hijjos",
  "Bank account": "Cuenta bancaria",
  IBAN: "IBAN",
  "working Sector": "Sector profesional",
  "line Of Business": "Rama de actividad",
  "professional Use": "Tipo de uso",
  "country Of Activity": "Pais de actividad",
  "Company name": "Nombre de empresa",
  "income Origin": "Origen de ingresos",
  "detail Of Income": "Detalle de los ingresos",
  /* ========================================== */
  /* SUMMARY ================================== */
  /* ========================================== */
  "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.":
    "Lee cada pestaña de tu contrato. Vas a poder aceptar las condiciones marcando la casilla de abajo, y firmar electrónicamente tu contrato vía un código que vas a recibir por SMS. Podrás luego descargar tus comprobantes.",
  "Confirmo haber leído y aceptado las Condiciones Generales de Alquiler y la Política de Privacidad. También autorizo el cargo del primer pago único relacionado con el contrato de alquiler en mi cuenta bancaria, así como el cargo mensual del alquiler.":
    {
      elementHtml: (props) => {
        const hrefContract = getStaticDocUrl(
          props?.tunnelData,
          "contract",
          "https://static-seib.evollis.com/pdf/contract_es.pdf"
        )
        const hrefPrivacy = getStaticDocUrl(
          props?.tunnelData,
          "privacy",
          "https://static-seib.evollis.com/pdf/privacy_es.pdf"
        )
        return (
          <React.Fragment>
            {" "}
            Confirmo haber leído y aceptado las
            <a href={hrefContract} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Condiciones Generales de Alquiler{" "}
            </a>
            y la{" "}
            <a href={hrefPrivacy} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Política de Privacidad.
            </a>{" "}
            También autorizo el cargo del primer pago único relacionado con el contrato de alquiler en mi cuenta
            bancaria, así como el cargo mensual del alquiler.
          </React.Fragment>
        )
      }
    },
  within: "sobre",
  "Edit my data": "Modificar mis datos",
  "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.":
    "Accepto recibir por vía electrónica ofertas comerciales por parte de Evollis.",
  "I oppose the receipt of commercial offers by post or telephone from BNP Paribas Personal Finance group companies.":
    "Me opongo a recibir ofertas comerciales por vía postal o electrónica por parte de Evollis.",
  /* ========================================== */
  /* NETHEOS ================================== */
  /* ========================================== */
  "Your product will be delivered to you after the final acceptance of the long-term rental contract and upon receipt of supporting documents by the rental company.":
    "Tu producto será entregado después de la acceptación definitiva del contrato de arrendamiento de larga duración y a recepción de los justificantes por parte del arrendador.",
  /* ========================================== */
  /* CONFIRMATION ============================= */
  /* ========================================== */
  "Request sent": "Solicitud enviada ",
  "Your file number is": "Tu número de contrato es el",
  "Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.":
    "La firma de tu solicitud ha finalizado con éxito. Recibirás un email con el Contrato de tu Solicitud de Renting que has firmado.",
  "We will contact you as soon as your file is treated":
    "En breve nos pondremos en contacto contigo para informarte sobre el estado de tu solicitud por correo electrónico.",
  "Thank you for your trust and see you soon !": "¡Muchas gracias por tu confianza!",
  "Request pre-accepted": "Solicitud preaceptada",
  "Pre accepted paragraph one": {
    elementHtml: (
      <>
        Para liberar la mercancía, asegúrese de que el <strong>expediente</strong> esté en estado{" "}
        <strong>"Aceptado - a la espera de financiación"</strong>.
      </>
    )
  },
  "Pre accepted paragraph two": {
    elementHtml: (
      <>
        <strong>¿Su cliente desea beneficiarse inmediatamente de su mercancía?</strong> Póngase en contacto con un
        asesor de Cetelem Location en el <strong>09 69 37 84 07</strong> de lunes a sábado de 9h a 19h30.
      </>
    )
  },
  "Pre accepted paragraph three": {
    elementHtml: (
      <small>
        (fuera de este horario, se le informará de la decisión tomada tras el estudio del expediente por el equipo de
        Cetelem Location)
      </small>
    )
  },
  "Pre accepted paragraph four": {
    elementHtml: <>Entregar el original del albarán de entrega del producto al cliente.</>
  },
  "Pre accepted paragraph five": {
    elementHtml: <>Subir el acta de entrega firmada por el cliente.</>
  },
  "Samsung APZ final page message":
    "Enhorabuena! Ya tienes tu solicitud tramitada! En pocos días podrás disfrutar de tu producto.\n\nRecuerda usar tu espacio cliente para todas las dudas que puedas tener.",
  "A problem occurred during finalization. You will be redirected shortly.":
    "Se ha producido un problema durante la finalización. Serás redirigido en breve.",
  "Unable to load payment configuration. Please try again.":
    "No se ha podido cargar la configuración del pago. Inténtalo de nuevo.",
  "Unable to start payment. Please try again.": "No se ha podido iniciar el pago. Inténtalo de nuevo.",
  "A problem occurred during finalization. Please try again.":
    "Se ha producido un problema durante la finalización. Inténtalo de nuevo.",
  "APZ Netheos recovery after finalize error":
    "No se pudo finalizar el pago con Aplazame de forma automática. Pulsa «Reintentar finalización» para obtener la sesión de firma, o contacta con soporte si el problema continúa.",
  "APZ Netheos recovery missing token":
    "Falta la sesión de firma. Pulsa «Reintentar finalización» para continuar, o recarga la página.",
  "Aplazame checkout status": "Estado del checkout Aplazame",
  "Retry finalization": "Reintentar finalización",
  "Please wait…": "Espera…",
  "Missing data for retry. Please reload or contact support.":
    "Faltan datos para reintentar. Recarga la página o contacta con soporte.",
  "The server did not return a signature session. Please try again or contact support.":
    "El servidor no devolvió una sesión de firma. Inténtalo de nuevo o contacta con soporte.",
  "Retry failed. Please try again.": "El reintento ha fallado. Vuelve a intentarlo.",
  Congratulations: "Enhorabuena",
  Product: "Producto",
  "№ contrato de renting": "№ contrato de renting",
  "Montly amount to be paid": "Cuota",
  Duration: "Duración",
  "Acceptance in principle": "Solicitud enviada",

  /* ========================================== */
  /* ACCEPTANCE PAGE ========================== */
  /* ========================================== */
  lets_go: "N/A",
  you_have_x_days_to: {
    propsValues: (props) => {
      return `N/A`
    }
  },
  /* ========================================== */
  /* LEGALS =================================== */
  /* ========================================== */
  "Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Location and after expiration of the legal withdrawal period. Personal Finance Location - SASU with a capital of € 1,500,000 - Headquarters: 1 boulevard Haussmann - 75009 Paris - RCS Paris N °433 911 799.":
    "La información requerida tiene por finalidad la gestión de tu solicitud de arrendamiento. A menos que se indique lo contrario, dicha información está obligatoria y debe ser completa, sino tu solicitud será denegada. Si eliges no comunicar la información, no podremos tratar tu solicitud. La información está destinada al arrendador Evollis, responsable de su tratamiento. A través de Evollis, podrás recibir propuestas de empresas socias. Para más información sobre el tratamiento de tus datos personales por Evollis y sobre tus derechos (derecho de acceso, de rectificación, de borrado, de límite de tratamiento, al traspaso de los datos, derecho de oposición y derecho de organizar la gestión de tus datos después de fallecimiento) puedes consultar el aviso de información sobre el uso de datos personales o bien contactarnos a la siguiente dirección EVOLLIS - Servicio Cliente – 22-26 quai de Bacalan - 33300 Bordeaux o enviando un correo electrónico a : protectiondonnees@evollis.com.",
  "The information requested is for the management and evaluation of your Service Contract. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for EVOLLIS, responsible for the processing. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by EVOLLIS and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer here to the use of your data or contact us at the following address EVOLLIS - Customer Service - 22 quai de Bacalan - 33300 Bordeaux or at protectiondonnees@evollis.com":
    "La información requerida tiene por finalidad la gestión de tu solicitud de arrendamiento. A menos que se indique lo contrario, dicha información está obligatoria y debe ser completa, sino tu solicitud será denegada. Si eliges no comunicar la información, no podremos tratar tu solicitud. La información está destinada al arrendador Evollis, responsable de su tratamiento. A través de Evollis, podrás recibir propuestas de empresas socias. Para más información sobre el tratamiento de tus datos personales por Evollis y sobre tus derechos (derecho de acceso, de rectificación, de borrado, de límite de tratamiento, al traspaso de los datos, derecho de oposición y derecho de organizar la gestión de tus datos después de fallecimiento) puede consultar el aviso de información sobre el uso de datos personales o bien contactarnos a la siguiente dirección EVOLLIS - Servicio Cliente - 22 quai de Bacalan - 33300 Bordeaux o enviando un correo electrónico a : protectiondonnees@evollis.com.",
  "Service contract managed by EVOLLIS - SAS with capital of € {shareCapitalFinancer} - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.":
    "Contrato de servicio gestionado por Evollis - SAS con capital de {shareCapitalFinancer} euros - Sede: 22-26 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N°530 612 571 - Número ORIAS: 13003909.",
  "Long-term rental contract, subject to acceptance of the file by the Lessor, Evollis, a Simplified Joint Stock Company under French law, with a capital of € {shareCapitalFinancer} , having its head office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Contrato de arrendamiento de larga duración, sujeto a aceptación por parte del arrendador Evollis y después de expiración del periodo legal de desistimiento. Evollis, SAS con un capital de {shareCapitalFinancer} euros, cuya sede se ubica en el 22-26 Quai de Bacalan 33300 Bordeaux, inmatriculada en el Registro del Comercio y Sociedades de Bordeaux con el número 530 612 571. Número fiscal intracomunitario: FR 195 306 125 71.",
  "Acepto el envio de comunicaciones comerciales sobre productos financieros y de seguros de entidades del Grupo BNP Paribas en España previa realizacíon de un perfilado de mis datos y consulta a sistema externos de información crediticia. Más información":
    {
      propsValues: () => {
        return <SamsungESOptin1 />
      }
    },
  "samsung es legals 1": {
    elementHtml: (props) => {
      const hrefInfo = getStaticDocUrl(
        props?.tunnelData,
        "information_previa_sto",
        "https://static-cetelem-es.evollis.com/pdf/information_previa_sto.pdf"
      )
      const hrefClause = getStaticDocUrl(
        props?.tunnelData,
        "cetelem_clause",
        "https://static-cetelem-es.evollis.com/pdf/Cláusula_informativa_primera_capa_proceso_contratación_150622.pdf"
      )
      return (
        <React.Fragment>
          <p>
            <small>
              *Al pulsar en validar confirmo que he leído y acepto{" "}
              <a href={hrefInfo} target="_blank" rel="noopener noreferrer" alt="">
                {" "}
                la información previa al contrato de Renting{" "}
              </a>{" "}
              y la{" "}
              <a href={hrefClause} target="_blank" rel="noopener noreferrer" alt="">
                {" "}
                política de protección de datos de Banco Cetelem, S.A.U.{" "}
              </a>
            </small>
          </p>
        </React.Fragment>
      )
    }
  },
  "samsung es legals 2":
    "Banco Cetelem, S.A.U. tratará sus datos personales para poder evaluar la solicitud de arrendamiento, implicando la consulta en sistemas externos de información crediticia o actividades para la prevención del fraude y control del riesgo, así como para, en caso de que proporcione su consentimiento marcando las casillas correspondientes que se le facilitarán a continuación, ejecutar los tratamientos allí informados. Tendrá derecho a solicitar el acceso a sus datos personales, y su rectificación o supresión, o la limitación de su tratamiento o a oponerse al tratamiento, así como el derecho a la portabilidad de los datos dirigiéndote mediante correo postal al Servicio al Consumidor en la dirección anteriormente indicada o mediante correo electrónico a la dirección SAC-quejasyreclamaciones@cetelem.es",
  "samsung es legals 3":
    "Texto legal: Contrato de arrendamiento de larga duración, sujeto a aceptación por parte del arrendador BANCO CETELEM, S.A.U. BANCO CETELEM S.A.U. es una entidad de crédito con domicilio social en Paseo de los Melancólicos, 14A, 28005-Madrid. Inscrita en el Registro Mercantil de Madrid en la Hoja M-66979, Tomo 4018, Fila 109, C.I.F. número A-78650348. Se encuentra inscrita en el Registro de Entidades de Banco de España bajo el número 0225 - Asociado en ASNEF, Nº 510. Email: servicio-web.clientes@cetelem.es. Te informamos que el Renting es ofrecido por BANCO CETELEM S.A.U",
  "Acepto el envío de comunicaciones comerciales sobre productos de terceras entidades con las que Banco Cetelem S.A.U. mantenga acuerdos comerciales, previo realizacíon de un perfilado de mis datos y consulta a sistemas externos de informacíon crediticia. Más información":
    {
      propsValues: () => {
        return <SamsungESOptin2 />
      }
    },
  /* ========================================== */
  /* ERROR PAGES ============================== */
  /* ========================================== */
  "Internal error": "Error interno",
  "The server was unable to process your request.": "El servidor  no ha podido tratar tu pedido.",
  "The server has encountered an error, and couldn't treat your request.":
    "el servidor ha encontrado un error, y no ha podido tratar tu pedido.",
  "Page not found": "Página no encontrada",
  "The page you're asking for doesn't exist or had been deleted":
    "La página que está buscando no existe o ha sido suprimida.",
  "Service unavailable": "Servicio no disponible",
  "Service is unavailable, please come back later.":
    "El servicio está temporalmente no disponible. Gracias por volver más tarde.",
  "Pending request": "Solicitud en espera",
  "We will send you an email allowing you to finalize your file later.":
    "Te vamos en enviar un email que te permitirá finalizar tu solicitud mas tarde.",
  "You have 2 days to finalize your request by uploading your supporting documents.":
    "Tienes 2 días para finalizar tu solicitud cargando tus documentos.",
  "Without your supporting documents, your file will be canceled within 3 days.":
    "Sin justificantes, tu solicitud será anulada en un plazo de 3 días.",
  /* ========================================== */
  /* VALIDATION =============================== */
  /* ========================================== */
  "Not a valid IBAN": "IBAN incorrecto",
  "IBAN must have 24 characters": "El IBAN debe tener 24 caracteres",
  Required: "Campo necesario",
  "Enter data": "Introducir los datos",
  "Invalid data": "Datos incorrectos",
  pdi_retail_opl: "Número de pedido",
  "Not a valid BIC": "BIC no válido",
  "Date is not valid": "fecha incorrecta",
  Maximum: "Máximo",
  characters: "caracteres",
  "maximum characters": "caracteres máximo",
  "Unauthorized characters": "Carácteres no autorizados",
  "Invalid postal code": "Código postal no válido",
  "Invalid format": "Formato no válido",
  "Minimum age must be > 18 years old": "La edad mínima debe ser de 18 años",
  "Maximum age must be < 110 years old": "La edad máxima debe ser inferior a 110 años",
  "Must be positive": "El número debe ser positivo",
  "minimum characters": "caracteres mínimo",
  "number of children must be contains between 0 and 10": "El número de hijos debe ser entre 0 y 10",
  "birthDate is not valid": "Fecha de nacimiento incorrecta",
  "employmentDate cannot be before birthDate":
    "La fecha de contratación en el empleo no puede ser anterior a la fecha de nacimiento ",
  "Year seniority bank cannot be before birth date":
    "La fecha de antiguedad en el banco no puede anterior a la fecha de nacimiento",
  "difference between employment date and birth date must be at least 16 years":
    "La diferencia entre la fecha de contratación en el empleo y la fecha de nacimiento debe ser de al menos 16 años",
  "difference between bank seniority date and birth date must be at least 16 years":
    "La diferencia entre la fecha de antiguedad en el banco y la fecha de nacimiento debe ser de al menos 16 años",
  "employmentDate cannot be in future": "La fecha de contratación en el empleo no puede ser en en el futuro",
  "Must be a whole number": "Debe ser un número entero",
  "Must be a number": "debe ser un número",
  "Email invalid": "Dirección email incorrecta",
  "Please assert you're the real card owner": "Marque para confirmar ser el propietario de esta tarjeta de pago",
  "Not a valid MM value": "Se requiere poner el mes al formato MM",
  "Not a valid YYYY date": "Se requiere poner el año al formato AAAA",
  "Not a valid date": "Fecha incorrecta",
  "Can't be before current year": "No puede ser previo al año actual",
  "Must be composed of 3 digits": "Debe ser compuesto de 3 cifras",
  "Must be composed of 12-19 digits": "Debe ser compuesto de 12-19 cifras",
  "Not a valid YYYY-MM-DD date": "Ingresa una fecha al formato DD/MM/AAAA",
  "Residence date cannot be before birth date": "La fecha de residencia no puede ser previa a la fecha de nacimiento",
  "This date cannot be in future": "Esta fecha no puede ser en el futuro",
  "Employment date cannot be before birth date":
    "La fecha de contratación no puede ser previa a la fecha de nacimiento",
  "Employment date cannot be in future": "La fecha de contratación no puede ser en el futuro",
  "Please pick a correct value": "Elige un valor correcto",
  "Invalid phone number": "Número inválido",
  "Not a valid YYYY/MM/DD date": "La fecha de caducidad es inválida",
  validator_invalidNetMounthlyIncomeFormat: "N/A",
  validator_endContractDateInFuture: "N/A",

  /* ========================================== */
  /* OK KO BACK =============================== */
  /* ========================================== */
  "Your request is already finalized": "Tu solicitud está ya finalizada",
  "You will receive a final response within 24 hours.": "Recibirás una respuesta definitiva en 24 horas",
  "Thank you for your request.": "Te agradecemos por tu pedido",
  "Your request has already been validated": "Tu pedido ha sido acceptado ya",
  "The information you have entered can no longer be changed.": "La información que ingresaste ya no se pueden cambiar",
  "Please click on the button below to finalize your order.":
    "Gracias por hacer clic en el botón de abajo para finalizar tu pedido",
  "Finalize your order": "Finaliza tu pedido",
  "Operation failed": "Tu solicitud falló",
  "Your order is canceled. The amount of the upfront will not be deducted from you.":
    "Te agradecemos la confianza depositada en esta entidad y esperamos tener la posibilidad de colaborar juntos en el futuro.",
  please_study_other_payment_means: " ",
  "Request denied": "Solicitud Denegada",
  "We regret to inform you that we cannot give a favorable response to your request.":
    "Lamentamos informarte de que una vez estudiados el conjunto de los datos facilitados para su solicitud, no ha sido posible aprobarla.",
  Maintenance: "Mantenimiento",
  "The app is temporarily unavailable.": "El aplicativo no está disponible temporalmente.",
  "Please come back later.": "Gracias por volver más tarde.",
  "Renew Order": "Renovar mi contratoe",
  generate_delivery_voucher: "Generar albarán de entrega",
  imei: "IMEI",
  numero_marquage: "Número de marcaje",
  final_page_import_document: "Importar un documento",
  finalize_later: "Finalizar más tarde",
  document_type: "N/A",

  /* ========================================== */
  /* LOGIN ================================== */
  /* ========================================== */
  "Bad credentials": "n/a",
  username: "n/a",
  password: "n/a",
  connect: "n/a",
  "need help": "n/a",
  "login page need help tooltip": "n/a",
  "User account is locked": "n/a",

  /* ========================================== */
  /* RESET PASSWORD  ========================== */
  /* ========================================== */
  password_expired: "n/a",
  old_password: "n/a",
  new_password: "n/a",
  verify_new_password: "n/a",
  change_password: "n/a",
  confirmation_password_matches_new_password: "n/a",
  old_password_matches_current_password: "n/a",
  different_password: "n/a",

  /* ========================================== */
  /* RETAIL ================================== */
  /* ========================================== */
  TOUS: "TOUS n/a",
  WAIT_SIGNATURE: "WAIT_SIGNATURE n/a",
  WAITING_DOCUMENTS: "WAITING_DOCUMENTS n/a",
  REJECTED: "REJECTED n/a",
  PJ_UPLOADES: "PJ_UPLOADES n/a",
  ACCEPTED_AWAITING_FUNDING: "ACCEPTED_AWAITING_FUNDING n/a",
  NOT_FINALIZED: "NOT_FINALIZED n/a",
  A_TRAITER_OCTROI: "A_TRAITER_OCTROI n/a",
  REFUSED_AFTER_DOCUMENT_ANALYSIS: "REFUSED_AFTER_DOCUMENT_ANALYSIS n/a",
  DEFAULT: "DEFAULT n/a",
  wrongFileExtensionMessage: "n/a wrongFileExtensionMessage",
  onlyAlphaNumericMessage: "n/a onlyAlphaNumericMessage",
  fiveMegaBytesMaximumFileMessage: "n/a fiveMegaBytesMaximumFileMessage",
  retail_patch_order_success_label: "Su número se ha registrado correctamente.",

  resume_order_fill_shipping_date_button_label: "n/a",

  one_lower_case_required: "n/a",
  one_upper_case_required: "n/a",
  one_number_required: "n/a",
  more_than_height_length: "n/a",
  previous: "n/a",
  next: "n/a",
  save: "n/a",
  change_identity_bloc_simplified_journey:
    "Si desea modificar los datos presentes en “Mi identidad”, póngase en contacto con nuestro servicio de atención al cliente en la siguiente dirección {adresse}",
  /* Algoan Bank Modal */
  algoanBankModal_loadingAria: "Cargando",
  algoanBankModal_loadingText: "Recuperando sus cuentas bancarias...",
  algoanBankModal_errorMessage: "Se ha producido un error. Por favor, inténtelo de nuevo más tarde.",
  algoanBankModal_retry: "Reintentar",
  algoanBankModal_titleSingle: "La cuenta bancaria en la que se le cargarán sus mensualidades.",
  algoanBankModal_titleMultiple: "Elija la cuenta bancaria en la que desea que se le carguen sus mensualidades.",
  algoanBankModal_continue: "Continuar",
  algoanBankModal_noAccount: "No hemos podido identificar ninguna cuenta bancaria a su nombre.",
  algoanBankModal_noAccountAdvice:
    "Por favor, realice un nuevo recorrido y utilice una cuenta bancaria de la que sea titular.",
  button_close: "Cerrar",
  /* Algoan Open Banking error codes */
  algoanBankModal_CURRENCY_NOT_SUPPORTED_title: "Divisa no compatible",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_message:
    "No podemos analizar su cuenta bancaria porque la divisa de su cuenta no es compatible con nuestro servicio. Utilice una cuenta en euros.",
  algoanBankModal_NO_CHECKING_ACCOUNT_title: "Ninguna cuenta corriente detectada",
  algoanBankModal_NO_CHECKING_ACCOUNT_message:
    "No hemos detectado ninguna cuenta corriente a su nombre. Utilice una cuenta bancaria corriente para continuar su solicitud.",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_title: "Tipo de cuenta desconocido",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_message:
    "El tipo de cuenta bancaria detectado no es compatible con nuestro análisis. Utilice una cuenta bancaria clásica.",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_title: "Cliente no titular (procuración)",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_message:
    "La cuenta bancaria utilizada no parece estar a su nombre. Utilice una cuenta de la que sea titular.",
  algoanBankModal_USAGE_NOT_SUPPORTED_title: "Cuenta profesional",
  algoanBankModal_USAGE_NOT_SUPPORTED_message:
    "Las cuentas profesionales no están aceptadas. Utilice una cuenta bancaria personal.",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_title: "No hay suficientes transacciones",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_message:
    "No disponemos de un historial bancario suficiente para analizar su situación. Utilice una cuenta con transacciones recientes.",
  algoanBankModal_UNKNOWN_title: "Caso no identificado",
  algoanBankModal_UNKNOWN_message:
    "Se ha producido un error al analizar su cuenta bancaria. Por favor, inténtelo de nuevo más tarde.",
  legalMentionBaseBloc_1: {
    elementHtml: (
      <React.Fragment>
        <p>
          <small>
            Contrato de alquiler a largo plazo (LLD), sujeto a la aceptación de la solicitud por parte del Arrendador,
            Evollis Iberia, Sociedad Limitada (sociedad unipersonal), de nacionalidad española, con domicilio en Pozuelo
            de Alarcón (Madrid), calle Luxemburgo, número 4, local 50, Urbanización Las Jaras. Su número de
            identificación fiscal (C.I.F.) es el B88637848. La solicitud de alquiler implica el pago de un primer
            alquiler y el suministro de la información necesaria para el estudio de la solicitud. El contrato de alquiler
            solo se formalizará definitivamente tras el examen y la aceptación de la solicitud por parte de Evollis
            Iberia. En caso de denegación de la solicitud de alquiler por parte de Evollis Iberia, cualquier importe
            abonado se reembolsará íntegramente lo antes posible. Evollis Iberia, en su calidad de Arrendador, tratará
            los datos personales facilitados con el fin de gestionar la solicitud. Estos datos son obligatorios para
            garantizar la correcta tramitación de la misma. La información completa relativa al tratamiento de datos
            personales realizado por Evollis Iberia y al ejercicio de los derechos previstos por la legislación en
            materia de protección de datos está disponible{" "}
            <a href="https://static-seib.evollis.com/pdf/privacy_es.pdf" target="_blank" rel="noopener noreferrer">
              aquí
            </a>
            .
          </small>
        </p>
      </React.Fragment>
    )
  },
  legalMentionBaseBloc_2:
    "Evollis Iberia cederá los derechos de cobro derivados del contrato de alquiler suscrito a Wizink Bank, S.A.U., con domicilio social en Ulises 16-18, 28043 Madrid, inscrita en el Registro Mercantil de Madrid competente con el CIF A81831067, y con Número de Identificación Fiscal: A-81831067, comunicándole los datos necesarios para permitir la realización de un análisis previo de solvencia, exigido para la evaluación de la operación.",
  legalMentionBaseBloc_3: {
    elementHtml: (
      <React.Fragment>
        <p>
          <small>
            WiZink Bank, en su calidad de cesionario de los derechos de cobro, consultará ficheros de información sobre
            solvencia patrimonial y crediticia, y tratará los datos facilitados por Evollis Iberia con el fin de evaluar
            la solvencia del solicitante, así como el riesgo y la viabilidad inherentes a la cesión, y llevará a cabo los
            tratamientos de datos necesarios para la gestión de los derechos de cobro cedidos. La información completa
            relativa al tratamiento de datos personales realizado por WiZink Bank y al ejercicio de los derechos
            previstos en la legislación sobre protección de datos está disponible{" "}
            <a href="https://aplazame.com/legal/privacidad-clientes/" target="_blank" rel="noopener noreferrer">
              aquí
            </a>
            .
          </small>
        </p>
      </React.Fragment>
    )
  },
  legalMentionBaseBloc_4:
    "Aplazame, marca del banco WiZink Bank, S.A.U., con domicilio social en Ulises 16-18, 28043 Madrid, inscrita en el Registro Mercantil de Madrid competente con el CIF A81831067, y con Número de Identificación Fiscal: A- 81831067."
}
